export const PARTS_OF_DAY_MAX = 9

export const enum BOOKING_FLOW {
  TIME_BASED = 'time_based',
  PROVIDER_BASED = 'provider_based',
}

export const PROVIDER_SELECTION_FEATURE_NAME = 'provider_selection'

export enum DIFFERENCE {
  WEEK = 'weeks',
  DAY = 'days',
  HOUR = 'hours',
}

export enum PARTS_OF_DAY {
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
  EVENING = 'evening',
}

export enum PART_OF_DAY_END_HOUR {
  MORNING = 12,
  AFTERNOON = 17,
  EVENING = 24,
}
